<template>
  <v-switch
    @change="handleSetNeedsAuth"
    v-model="isAuthNeeded"
    :label="$t('appointment.formCreate.labels.needsAuthorization')"
    :ripple="false"
    class="mt-1"
    inset
  />
</template>

<script>
import { mapMutations } from 'vuex'

export default {
  name: 'MeetingAuth',

  data() {
    return {
      isAuthNeeded: false,
    }
  },

  methods: {
    ...mapMutations(['setAppointmentFields']),

    handleSetNeedsAuth(value) {
      this.setAppointmentFields({
        needs_authorization: value,
      })
    },
  },
}
</script>
